import { Icon } from '@chakra-ui/react';

export default function SFSquareAndPencil(props) {
  return (
    <Icon
      width={4}
      height={4}
      viewBox='0 0 16 16'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M14.7734 1.95315L13.7031 0.875024L14.2734 0.312524C14.5312 0.0625237 14.9141 0.0312737 15.1562 0.273461L15.3359 0.460961C15.6016 0.718774 15.6016 1.09377 15.3359 1.37502L14.7734 1.95315ZM5.375 10.4766C5.22656 10.5391 5.07031 10.3594 5.13281 10.2266L5.83594 8.75784L13.125 1.46877L14.1953 2.52346L6.89844 9.81252L5.375 10.4766ZM2.53125 15.5391C0.90625 15.5391 0.078125 14.7344 0.078125 13.1172V4.11721C0.078125 2.50784 0.90625 1.69534 2.53125 1.69534H11.3828L10.125 2.95315H2.55469C1.77344 2.95315 1.33594 3.37502 1.33594 4.18752V13.0547C1.33594 13.8672 1.77344 14.2813 2.55469 14.2813H11.6875C12.2344 14.2813 12.6641 13.8672 12.6641 13.0547V5.55471L13.9219 4.2969V13.1172C13.9219 14.7344 13.1094 15.5391 11.7031 15.5391H2.53125Z' />
    </Icon>
  );
}
